class MandatoryFeedbackEntity {
  constructor(object = {}) {
    this.definition = object.definition || "";
    this.question = object.question || "";
    this.sp_question = object.sp_question || null;
    this.answer = object.answer || [];
    this.selectedOption = [];
    this.sequenceOfConfiguration = object.sequence_of_configuration;
    this.score = object.score;
    this.behaviour = object.behaviour;
    this.wrongRes = false;
  }

  setSelectedOption(val, type){
    if(type ==='multi'){
      if(this.selectedOption.find((i)=>i.value === val.value)){
        this.selectedOption.splice(this.selectedOption.indexOf(val), 1);
      }
      else{
        this.selectedOption.push(val);
      }
    }
    else{
      this.selectedOption = [val]
    }
  }

  isResponseWrong(){
    this.wrongRes = true;
  }

  resetForm(){
    this.wrongRes = false;
  }

  toJSON() {
    const { definition, question, sequenceOfConfiguration, score, behaviour } = this;
    return {
      definition,
      behaviour,
      question,
      answer: this.selectedOption,
      score,
      sequence_of_configuration: sequenceOfConfiguration,
    };
  }
}

export default MandatoryFeedbackEntity;
